import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LinkTypeFiveComponent } from './link-type-five.component';
import { ImagesModule } from '../../images';
import { TranslocoModule } from '@jsverse/transloco';



@NgModule({
  declarations: [LinkTypeFiveComponent],
  exports: [LinkTypeFiveComponent],
  imports: [
    CommonModule,
    ImagesModule,
    TranslocoModule
  ]
})
export class LinkTypeFiveModule { }
